import { escapeRegExp, orderBy } from "lodash";
import { useMemo } from "react";
import { SortOrderMap, SortValueGetterMap } from "./constant";
import { Customer, CustomersSorting, Tag } from "./models";
import { Roles } from "@arelia-types/index";

export function useCustomersList(customers: Customer[], sortCustomersBy: CustomersSorting, searchValue: string, includeTestUsers: boolean, selectedTags: Tag[]) {

  const customersList = useMemo(() => {
    if (!customers) return [];
    let ambassadors = customers.filter(c => c.role === Roles.Ambassador);
    let restUsers = customers.filter(c => c.role !== Roles.Ambassador);

    ambassadors = orderBy(
      ambassadors,
      [SortValueGetterMap[sortCustomersBy]],
      [SortOrderMap[sortCustomersBy]]
    );

    restUsers = orderBy(
      restUsers,
      [SortValueGetterMap[sortCustomersBy]],
      [SortOrderMap[sortCustomersBy]]
    );

    if (searchValue) {
      const pattern = new RegExp(escapeRegExp(searchValue), "i");

      ambassadors = ambassadors.filter(customer =>
        pattern.test(customer.displayName as string) || 
        pattern.test(customer.fullName as string) || 
        pattern.test(customer.email as string) ||
        (customer.band?.name && pattern.test(customer.band.name as string))
      );

      restUsers = restUsers.filter(customer =>
        pattern.test(customer.displayName as string) || 
        pattern.test(customer.fullName as string) || 
        pattern.test(customer.email as string) ||
        (customer.band?.name && pattern.test(customer.band.name as string))
      );
    }

    if (!includeTestUsers) {
      ambassadors = ambassadors.filter(c => !c.role || c.role !== Roles.TestUser)
      restUsers = restUsers.filter(c => !c.role || c.role !== Roles.TestUser)
    }

    if (selectedTags.length > 0) {
      ambassadors = ambassadors.filter(customer => selectedTags.some(tag => customer[tag.prop] === tag.val));
      restUsers = restUsers.filter(customer => selectedTags.some(tag => customer[tag.prop] === tag.val));
    }

    return [...ambassadors, ...restUsers];
  }, [sortCustomersBy, searchValue, includeTestUsers, customers, selectedTags]);

  return customersList;
}
